import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Uploading a New File to Pliable',
  content: `
If you have a file-based data source in Pliable, you can easily append or replace the data any time it changes.

# Step 1: Export the data

Make sure the first row of your spreadsheet contains the names of the columns. Sometimes spreadsheets have additional information in the first few rows of the file (user name, file name, date, etc). These can be removed.

## Google Sheets

If your spreadsheet is in Google Sheets, you can export it to a CSV by going to the File menu, clicking on Download, and then selecting CSV. Note that if your spreadsheet has multiple sheets, each one will be downloaded as a CSV and you will need to select the correct sheet to load into Pliable.

## Excel

You can upload an Excel spreadsheet directly to Pliable (skip to step 2).

# Step 2: Load it into Pliable

1. Go to Pliable and log in if necessary.

2. Make sure you are in **DEVELOP** mode so you can make changes. You can switch to DEVELOP mode by using the menu at the top right of your screen.

3. Click on **Sources** in the top navigation, and then click on **Flat Files**.

4. Find the name of the data source you want to add to. If you need to create a new data source (if this is the first time you are uploading data from this file) you can do so by clicking on **"Upload New"**.

5. Click on the source to view its data.

6. Navigate to **Files** using the sub-navigation in the center/top portion of your screen (next to "View Data" and "Configure").

7. If you want to **REPLACE** the data, you can first remove any existing files, and then upload your new file using the file uploader. If you want to **APPEND** the data, you can simply upload your file without deleting the old files.

# Step 3: Publish and build

Once your file is uploaded, you can publish your changes and run a production build. To publish your changes, you can click on the **Develop Mode** menu at the top of your screen and select **Publish Changes**. You will then be presented with a list of pending changes, which should just include the file you uploaded. If there are additional changes, you may want to talk to other members of your team to make sure those are ready to be published.

Once you're ready, click **"Confirm Publish"**.

You are now in **PRODUCTION** mode. All you have to do now is run a full rebuild of your data model by clicking on the blue **"Build"** button at the top of your screen. This will automatically process the new data you uploaded and add it to any connected entities and reports.
`,
};

export default doc;
